import { ListHomeScreenBanners } from './__generated__/ListHomeScreenBanners'
import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListHomeScreenBanners {
    homeScreenBanners: homeScreenBannersV2(input: { includeDisabled: true }) {
      id
      title
      description
      backgroundColor
      positionInFeed
      enabled
      buttons {
        title
        deepLinkUrl
      }
    }
  }
`

export const useListHomeScreenBanners = () =>
  useQuery<ListHomeScreenBanners>(QUERY, {
    fetchPolicy: 'network-only'
  })
